import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ChartDropEvent, ChartNode } from '../models/chart-node.model';

// Drag & drop state shared between the cards of one chart. Provided by OrgChartV2Component.
@Injectable()
export class OrgChartDragService {

  enabled = false;
  dragged: ChartNode | null = null;
  readonly dropped = new Subject<ChartDropEvent>();

  // Set by the page so the descendant check can use the tree helpers.
  isSameOrDescendant: (ancestor: ChartNode, node: ChartNode) => boolean = () => false;

  start(node: ChartNode) {
    this.dragged = this.enabled ? node : null;
  }

  end() {
    this.dragged = null;
  }

  canDropOn(target: ChartNode): boolean {
    const dragged = this.dragged;
    if (!dragged || !target || dragged === target) {
      return false;
    }
    switch (dragged.type) {
      case 'employee':
        return target.type === 'position'
          && !target.employees.some(emp => emp.id === dragged.id);
      case 'position':
      case 'organization':
        return target.type === dragged.type
          && dragged.parentId !== target.id
          && !this.isSameOrDescendant(dragged, target);
    }
  }

  drop(target: ChartNode) {
    if (this.canDropOn(target)) {
      this.dropped.next({ dragged: this.dragged, target });
    }
    this.end();
  }
}
